import React, { useState } from "react";
import { useReveal } from "./Hooks";
import {
  RevealWrapper,
  SectionContainer,
  SectionLabel,
  SectionTitle,
  SectionSubtitle,
  HighlightsWrapper,
  HighlightsGrid,
  HighlightCard,
  HighlightIconBox,
  HighlightTitle,
  HighlightText,
} from "../Styles";
import { Icons } from "./Icons";
import useWebinar from "../../../../hooks/useWebinar";

function HighlightCards({ icon, title, text, delay }) {
  const { ref, visible } = useReveal(delay);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <RevealWrapper ref={ref} $visible={visible}>
      <HighlightCard
        $hovered={isHovered}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <HighlightIconBox $hovered={isHovered}>
          {Icons[icon] ?? Icons.bolt}
        </HighlightIconBox>
        <HighlightTitle>{title}</HighlightTitle>
        <HighlightText>{text}</HighlightText>
      </HighlightCard>
    </RevealWrapper>
  );
}

function Highlights() {
  const { config } = useWebinar();
  const highlightsData = config?.highlights;

  const headingReveal = useReveal(0);
  const titleReveal = useReveal(80);
  const subtitleReveal = useReveal(140);

  if (!highlightsData?.show) return null;

  const visibleItems = highlightsData.items?.filter((item) => item.show) ?? [];

  return (
    <HighlightsWrapper id="highlights">
      <SectionContainer>
        <RevealWrapper ref={headingReveal.ref} $visible={headingReveal.visible}>
          <SectionLabel>{highlightsData.sectionLabel}</SectionLabel>
        </RevealWrapper>

        <RevealWrapper ref={titleReveal.ref} $visible={titleReveal.visible}>
          <SectionTitle>{highlightsData.sectionTitle}</SectionTitle>
        </RevealWrapper>

        <RevealWrapper
          ref={subtitleReveal.ref}
          $visible={subtitleReveal.visible}
        >
          <SectionSubtitle>{highlightsData.sectionSubtitle}</SectionSubtitle>
        </RevealWrapper>

        <HighlightsGrid>
          {visibleItems.map((item, index) => (
            <HighlightCards key={item.id} {...item} delay={index * 60} />
          ))}
        </HighlightsGrid>
      </SectionContainer>
    </HighlightsWrapper>
  );
}

export { Highlights };
